export const actions: any = [
  {
    title: 'Add by year, make, model',
    action: 'add-fitment',
    hidden: false,
    icon: 'add-ymm-icon',
  },
  {
    title: 'Edit Columns',
    action: 'edit-columns',
    hidden: false,
    icon: 'columns-icon',
  },
];
